import { render } from "./Champions.vue?vue&type=template&id=1f77e6a0"
import script from "./Champions.vue?vue&type=script&lang=js"
export * from "./Champions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/house/Champions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f77e6a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f77e6a0', __exports__)) {
    api.reload('1f77e6a0', __exports__)
  }
  
  module.hot.accept("./Champions.vue?vue&type=template&id=1f77e6a0", () => {
    api.rerender('1f77e6a0', render)
  })

}


export default __exports__